import React from 'react';
import { FovDivider, FovToggle, VerticalSpacer } from 'components';
import { ProtectedContent } from 'components/generic/ProtectedContent';
import { ToggleContainer } from './RPCFormStyles';

const DebugToggleSection = ({ debugState, setDebugState }) => {
  return (
    <ProtectedContent>
      <FovDivider />
      <VerticalSpacer size={25} />

      <ToggleContainer>
        Debug Package

        <FovToggle
          checked={!!debugState}
          name='debugToggle'
          callback={() => setDebugState(!debugState)}
        />
      </ToggleContainer>

      <VerticalSpacer size={25} />
    </ProtectedContent>
  );
};

export default DebugToggleSection;

